export { DtvCompetitorComparisonTable as default } from './dtv-competitor-comparison-table';
